import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

const authHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export interface IUnknownTag {
    _id: string;
    tagName: string;
    tagType: "primary" | "subtag";
    correspondingPrimary: string;
    correspondingSubtags: string[];
    banished: boolean;
    createdAt: string;
}

export type UnknownTagFilter = "all" | "empty" | "primary_empty" | "subtag_empty" | "filled" | "banished";

export interface IBanishedEventEstablishment {
    _id: string;
    name: string;
    siren: string;
    hide: boolean;
}

export interface IBanishedEvent {
    _id: string;
    companyName: string;
    eventType: string | null;
    eventTypes?: { type: string; detectedAt: string }[];
    detectedAt: string;
    sourceUrl?: string;
    source?: string;
    notes?: string;
    banishedTagsFound: string[];
    establishment: IBanishedEventEstablishment | null;
}

export interface IBanishedTagRef {
    _id: string;
    tagName: string;
}

export interface BanishedEventsResponse {
    data: IBanishedEvent[];
    meta: { total: number; page: number; limit: number; totalPages: number };
    banishedTags: IBanishedTagRef[];
}

export interface UnknownTagsResponse {
    data: IUnknownTag[];
    meta: { total: number; page: number; limit: number; totalPages: number };
}

export const getUnknownTags = async (params: {
    filter?: UnknownTagFilter;
    search?: string;
    page?: number;
    limit?: number;
}): Promise<UnknownTagsResponse> => {
    const res = await axios.get(`${API_URL}/admin/unknown-tags`, {
        headers: authHeaders(),
        params,
    });
    return res.data;
};

export interface TagOptions {
    categories: string[];
    subCategories: string[];
}

export const getTagOptions = async (): Promise<TagOptions> => {
    const res = await axios.get(`${API_URL}/admin/unknown-tags/options`, {
        headers: authHeaders(),
    });
    return res.data;
};

export const triggerBackfill = async (): Promise<{ message: string }> => {
    const res = await axios.post(`${API_URL}/admin/unknown-tags/trigger-backfill`, {}, {
        headers: authHeaders(),
    });
    return res.data;
};

export const updateUnknownTag = async (
    id: string,
    data: { correspondingPrimary?: string; correspondingSubtags?: string[] }
): Promise<IUnknownTag> => {
    const res = await axios.patch(`${API_URL}/admin/unknown-tags/${id}`, data, {
        headers: authHeaders(),
    });
    return res.data;
};

export const banishTag = async (id: string): Promise<IUnknownTag> => {
    const res = await axios.patch(`${API_URL}/admin/unknown-tags/${id}/banish`, {}, {
        headers: authHeaders(),
    });
    return res.data;
};

export const saveEventNote = async (eventId: string, note: string): Promise<{ ok: boolean }> => {
    const res = await axios.patch(
        `${API_URL}/admin/unknown-tags/events/${eventId}/note`,
        { note },
        { headers: authHeaders() }
    );
    return res.data;
};

export const getBanishedEvents = async (params: {
    page?: number;
    limit?: number;
}): Promise<BanishedEventsResponse> => {
    const res = await axios.get(`${API_URL}/admin/unknown-tags/banished-events`, {
        headers: authHeaders(),
        params,
    });
    return res.data;
};
